/**
 * ChannelViewContainer component.
 */
import SelectViewContainer from '@components/atoms/container/selectViewContainer';
import ChannelViewTitle from '@components/atoms/text/channelViewTitle';
import ChannelViewWindow from '@components/atoms/images/channelViewWindow';
import SelectViewButton from '@components/atoms/buttons/selectViewButton';
import StyledChannelViewContainer from '@components/atoms/container/styledChannelViewContainer';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useList from '@shared/components/utils/hooks/useList';
import type Props from '@shared/types/props/pressable';
import { selectMagicRemoteEnabled } from '@shared/store/slices/magicRemote.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Props for the ChannelViewContainer component.
 * */
type ChannelViewProps = {
  action: () => void;
  text: string;
  Icon: React.FC<Props>;
  image: string;
  index: number;
};

/**
 * Renders a container with a channel view window and a select view button.
 */
export default function ChannelViewContainer({
  text,
  Icon,
  image,
  index,
  action,
}: ChannelViewProps) {
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  const { focused, listIndex } = useList(index);
  const buttonFocused = !enabled && focused && listIndex === index;
  return (
    <StyledChannelViewContainer>
      <SelectViewContainer>
        <Icon width={43} height={46} />
        <ChannelViewTitle>{text}</ChannelViewTitle>
      </SelectViewContainer>
      <ChannelViewWindow src={image} />
      <SelectViewButton focused={buttonFocused} onClick={action}>
        {TranslationManager.get('PAGES.CHANNELS_CHOICE.BUTTON')}
      </SelectViewButton>
    </StyledChannelViewContainer>
  );
}
